import React from 'react';
import { Link } from 'react-router';

class Item extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let className = [];
        if(this.props.active) {
            className.push("active");
        }

        if(this.props.className) {
            className.push(this.props.className);
        }




        return (
            <Link onClick={this.props.trigger_dark ? this.props.callback : null} to={this.props.path} className={className.join(' ')}>
                <span className="m2sidebar__icon"><svg dangerouslySetInnerHTML={{__html: this.props.icon}}></svg></span>
                <span className="m2sidebar__text">{this.props.title}</span>
            </Link>
        );
    }
}

export default Item;


// WEBPACK FOOTER //
// ./src/components/Sidebar/Item.js